import { User } from 'types/user'

export const getUserNameSurname = (user?: User) => {
  return [user?.name, user?.surname].filter(Boolean).join(' ')
}
